import { ThemesEnum } from '../providers/Theme/types';

export enum BackgroundType {
	PATTERN = 'pattern',
	IMAGE = 'image',
	COLOR = 'color',
}

export type MediaItem = {
	createdAt: string;
	ext: string;
	filename: string;
	height: number;
	mime: string;
	name: string;
	originalName: string;
	size: number;
	type: string;
	updatedAt: string;
	url: string;
	width: number;
	_id: string;
};

export type defaultBackgroundPattern = {
	filename: string;
	size: number;
	url: string;
	preset?: boolean;
};

type StylesBackgroundType = {
	type: BackgroundType;
	value?: string | MediaItem | defaultBackgroundPattern;
	options?: {
		opacity?: number;
		color?: string;
		backgroundColor?: string;
	};
};

type StylesType = {
	bgColor: string;
	fontColor: string;
	primaryColor: string;
	googleFontName?: string;
	fontName?: string;
	isWhiteBackground: boolean;
	background?: StylesBackgroundType;
	theme?: ThemesEnum;
};

export default StylesType;
